import type { JobCardStatus } from '../types/job';

export const JOB_CARD_STATUS_CONFIG: Record<JobCardStatus, { label: string; className: string }> = {
  not_started: {
    label: 'Not Started',
    className: 'bg-gray-100 text-gray-800 border-gray-300',
  },
  drafting: {
    label: 'Drafting',
    className: 'bg-orange-100 text-orange-800 border-orange-300',
  },
  ready: {
    label: 'Ready',
    className: 'bg-yellow-100 text-yellow-800 border-yellow-300',
  },
};

export function getJobCardStatusLabel(status: JobCardStatus): string {
  return JOB_CARD_STATUS_CONFIG[status].label;
}

export const JOB_CARD_STATUS_OPTIONS = (Object.keys(JOB_CARD_STATUS_CONFIG) as JobCardStatus[]).map(
  (value) => ({ value, label: JOB_CARD_STATUS_CONFIG[value].label })
);
